import React from 'react';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import CustomPagination from '../CustomPagination/CustomPagination';

const CustomStatusBarPagination = React.memo(({ count, pageCountOverride }) => {
  const { page, onPageChange, limit = 25 } = useTableContext();

  if (!(count > 0)) return null;

  return (
    <div className="bg-red flex h-full flex-wrap items-center space-x-4 text-sm">
      <CustomPagination
        onPageChange={onPageChange}
        perPage={limit}
        totalItems={count}
        page={page}
        pageCountOverride={pageCountOverride}
      />
    </div>
  );
});

export { CustomStatusBarPagination };
